<template>
  <v-footer fixed height="auto" class="footer white">
    <div class="footer-player">
      <FooterPlayerArtistImage :title="music.title" :artistImage="music.artistImage" @clickMethod="$emit('clickMethod')"/>
      <div class="footer-player-container">
        <div class="footer-player__main-controller" v-show="music.title">
          <PlayerPrevBtn/>
          <PlayPauseBtn class="footer-player__play-pause-btn"/>
          <PlayerNextBtn/>
        </div>
        <div class="footer-player__tune-information">
          <div class="footer-player__tune-title"
               v-if="music.title">
            <MarqueeMessage :message="music.title"/>
          </div>
          <div class="footer-player__tune-title" v-else>曲未選択</div>
          <div class="footer-player__tune-artist">
            <MarqueeMessage :message="music.artist"/>
          </div>
        </div>
        <div class="footer-player__favorite-controller" v-show="music.title">
          <FavoriteStarBtn :productId=parseInt(music.productId) />
        </div>
        <div class="footer-player__sub-controller" v-show="music.title">
          <MusicTimeSlider class="footer-player__music-time-slider"/>
          <RepeatBtn/>
          <PlayerShuffleBtn/>
          <MuteBtn/>
        </div>
        <div class="footer-player__phone-controller" v-show="music.title">
          <PlayPauseBtn/>
          <PlayerNextBtn/>
        </div>
      </div>
    </div>
  </v-footer>
</template>
<script>
import RepeatBtn from '@/components/atoms/RepeatBtn'
import FavoriteStarBtn from '@/components/atoms/FavoriteStarBtn'
import MuteBtn from '@/components/atoms/MuteBtn'
import PlayPauseBtn from '@/components/atoms/PlayPauseBtn'
import FooterPlayerArtistImage from '@/components/atoms/FooterPLayerArtistImage'
import PlayerPrevBtn from '@/components/atoms/PlayerPrevBtn'
import PlayerNextBtn from '@/components/atoms/PlayerNextBtn'
import PlayerShuffleBtn from '@/components/atoms/PlayerShuffleBtn'
import MusicTimeSlider from './MusicTimeSlider'
import MarqueeMessage from '@/components/atoms/MarqueeMessage'
export default {
  name: 'FooterPlayer',
  components: {
    MarqueeMessage,
    MusicTimeSlider,
    PlayerPrevBtn,
    PlayerNextBtn,
    FooterPlayerArtistImage,
    PlayPauseBtn,
    MuteBtn,
    FavoriteStarBtn,
    RepeatBtn,
    PlayerShuffleBtn
  },
  computed: {
    music () {
      return this.$store.getters['musicPlayerModuleGetNowPlayTuneData']
    }
  }
}
</script>
<style scoped>
  footer {
    z-index: 199;
  }
  .footer-player {
    width: 100%;
    height: 72px;
    display: flex;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2),
    0 1px 1px 0 rgba(0, 0, 0, .14),
    0 1px 3px 0 rgba(0, 0, 0, .12);
    position: relative;
    color: rgba(0, 0, 0, .87);
    background-color: #fff;
    text-decoration: none;
    vertical-align: middle;
  }
  .footer-player-container {
    display: flex;
  }
  .footer-player__main-controller {
    width: 12rem;
    height: fit-content;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .footer-player__play-pause-btn /deep/ .icon {
    font-size: 2.5rem;
  }
  .footer-player__tune-information {
    height: fit-content;
    margin: auto;
    margin-left: 2rem;
    width: 20rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .footer-player__tune-title {
    font-size: 14px;
    margin-right: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .footer-player__tune-artist {
    font-size: 12px;
    color: #666;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .footer-player__sub-controller {
    display: flex;
    height: fit-content;
    margin: auto;
    position: absolute;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: 1rem;
    right: 0;
    width: 35%;
  }
  .footer-player__favorite-controller {
    height: fit-content;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .footer-player__phone-controller {
    display: none;
  }
  @media screen and (max-width: 960px){
    .footer-player__main-controller,
    .footer-player__favorite-controller,
    .footer-player__sub-controller {
      display: none;
    }
    .footer-player__tune-information {
      margin-left: 0.75rem;
      width: 13rem;
    }
    .footer-player__phone-controller {
      display: flex;
      height: fit-content;
      padding-top: 12px;
      padding-bottom: 12px;
      position: absolute;
      right: 1rem;
      width: 5rem;
    }
  }
  .--active /deep/ .icon{
    color: #15c06a!important;
  }
  .--notActive /deep/ .icon{
    color: #bdbdbd!important;
  }
  /deep/ .input-group.input-group--slider {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Organisms/FooterPlayer.vue